import { FC } from 'react';

import { Tabs } from '@awsui/components-react';

import UserAccountPendingRequestTable from '../userAccountPendingRequestTable';
import UserAccountAllRequestTable from '../userAccountAllRequestTable';

interface ViewProps {}

const View: FC<ViewProps> = () => {
  return (
    <Tabs
      variant="container"
      tabs={[
        {
          label: 'Pending',
          id: 'pending',
          content: <UserAccountPendingRequestTable />
        },
        {
          label: 'All',
          id: 'all',
          content: <UserAccountAllRequestTable />
        }
      ]}
    />
  );
};
export default View;
